require("overlayscrollbars/js/jquery.overlayScrollbars.min");
require("../lib/jquery.lazyload.min");
require("../lib/jquery.form.min");
require("../lib/Jcrop/jquery.Jcrop.min");
require("../lib/turn.min");
require("../lib/jquery-ui.min");
require("../lib/scale-img-1.0");
window.ImagesLoaded = require("../lib/imagesloaded.pkgd.min");
window.rowGrid = require("../lib/jquery.row-grid.min");
window.ImagesLoaded.makeJQueryPlugin($);
const { event, error, get } = require("jquery");
var jQueryBridget = require("jquery-bridget");
var Masonry = require("masonry-layout");
const e = require("../lib/imagesloaded.pkgd.min");
jQueryBridget("masonry", Masonry, $);
window.general = require("./common/general");
window.JSCookie = require("js-cookie");
window.JSZip = require("jszip");
window.FileSaver = require("file-saver");
require("../js/common/gt");
require("../js/common/sem");

$(function () {
  // 浏览量统计
  window.actionView = function (action) {
    const data = {
      iUserType: P_UserType_action, //用户类型
      iUserId: P_AccountId, //用户ID
      sChildUserId: "", //子账号id
      iSite: 14, //站点
      sLang: "cn", //语言
      ...action,
    };
    if (P_UserType == "VIP" && P_AccountType == "child") {
      data.sChildUserId = P_UserId; //子账号
    }
    $.ajax({
      url:
        "//api.pop136.com/internal/statistics.php?action=view&" + Math.random(),
      data: data,
      type: "get",
      dataType: "jsonp",
      jsonp: "callback",
    });
  };

  // 真实查看
  window.actionRview = function (action) {
    const data = {
      iUserType: P_UserType_action, //用户类型
      iUserId: P_AccountId, //用户ID
      sChildUserId: "", //子账号id
      iSite: 14, //站点
      sLang: "cn", //语言
      ...action,
    };
    if (P_UserType == "VIP" && P_AccountType == "child") {
      data.sChildUserId = P_UserId; //子账号
    }
    $.ajax({
      url:
        "//api.pop136.com/internal/statistics.php?action=rview&" +
        Math.random(),
      data: data,
      type: "get",
      dataType: "jsonp",
      jsonp: "callback",
    });
  }

  // 下载统计
  window.actionDown = function (action) {
    const data = {
      iUserType: P_UserType_action, //用户类型
      iUserId: P_AccountId, //用户ID
      sChildUserId: "", //子账号id
      iSite: 14, //站点
      sLang: "cn", //语言
      ...action,
    };
    if (P_UserType == "VIP" && P_AccountType == "child") {
      data.sChildUserId = P_UserId; //子账号
    }
    $.ajax({
      url:
        "//api.pop136.com/internal/statistics.php?action=down&" + Math.random(),
      data: data,
      type: "get",
      dataType: "jsonp",
      jsonp: "callback",
    });
  };

  // gio统计
  $("body").on("click", ".tag_click", function (e) {
    e.stopPropagation();
    if($(this).attr("data-gio-imp-attrs")){
       var json = JSON.parse($(this).attr("data-gio-imp-attrs"))
      gio("track", "tag_click", json);
    }
   if($(this).hasClass('js_tag_click')){
       var tag = $(this).attr("data-name")
        let urlObj = new URL(window.location.href);
        let params = new URLSearchParams(urlObj.search);
        // tag = params.get('key') ? params.get('key') + ' ' + tag : tag
        let key = $('#global_search_value').attr('data-key') ?? '';
        tag = key + ' ' + tag
        params.set('key', encodeURIComponent(tag) );
        urlObj.search = params.toString();
        window.open(urlObj.toString(), "_self");
   }
  })







  /** 通用滚动条 start
   * 属性: js_overlay_scrollbars（父级） (推荐给内容包裹盒子, 如 overlay_content scrrollbar_content（子级） 等)
   */
  $("[js_overlay_scrollbars]").overlayScrollbars({
    sizeAutoCapable: true,
    paddingAbsolute: true,
    scrollbars: {
      clickScrolling: true,
    },
  });
  /* 通用滚动条 end */

  /* 通用定位滚动跟随 start */
  window.addEventListener(
    "scroll",
    _.throttle(
      _.partial(function () {
        $("[js_fixed_scrollx_follow]").each(function (idx, el) {
          if (el.clientWidth > document.documentElement.clientWidth) {
            el.style.marginLeft = -document.documentElement.scrollLeft + "px";
          } else {
            el.style.marginLeft = "0px";
          }
        });
      }),
      300,
      { leading: false }
    ),
    false
  );
  /* 通用定位滚动跟随 end */

  /* 通用图片效果 start */
  // 瀑布流 属性: js_common_masonry masonry_item
  $commonMasonry = $("[js_common_masonry]");
  if ($commonMasonry.length) {
    $commonMasonry.imagesLoaded(function () {
      $commonMasonry.masonry({
        itemSelector: "[masonry_item]",
        columnWidth: "[masonry_item]",
        percentPosition: true,
        horizontalOrder: true,
        transitionDuration: 0,
      });
    });
  }
  window.masonryLayoutLoad = function () {
    $commonMasonry.length &&
      $commonMasonry.imagesLoaded(function () {
        $commonMasonry.masonry("layout");
      });
  };

  // 懒加载 属性: common_lazy data-original 值: report style pattern book
  $('img[common_lazy=""][data-original]').lazyload({
    effect: "fadeIn",
    failure_limit: 12,
    load: masonryLayoutLoad,
    event: "sporty",
  });
  $('img[common_lazy=""][data-original]').trigger("sporty");

  $('img[common_lazy="report"][data-original]').lazyload({
    effect: "fadeIn",
    failure_limit: 12,
    placeholder: "/static/images/loading/report.png",
    load: masonryLayoutLoad,
    event: "sporty",
  });
  $('img[common_lazy="report"][data-original]').trigger("sporty");

  $('img[common_lazy="style"][data-original]').lazyload({
    effect: "fadeIn",
    failure_limit: 12,
    placeholder: "/static/images/loading/style.png",
    load: masonryLayoutLoad,
    event: "sporty",
  });
  $('img[common_lazy="style"][data-original]').trigger("sporty");

  $('img[common_lazy="pattern"][data-original]').lazyload({
    effect: "fadeIn",
    failure_limit: 12,
    placeholder: "/static/images/loading/pattern.png",
    load: masonryLayoutLoad,
    event: "sporty",
  });
  $('img[common_lazy="pattern"][data-original]').trigger("sporty");

  $('img[common_lazy="book"][data-original]').lazyload({
    effect: "fadeIn",
    failure_limit: 12,
    placeholder: "/static/images/loading/book.png",
    load: masonryLayoutLoad,
    event: "sporty",
  });
  $('img[common_lazy="book"][data-original]').trigger("sporty");
  /* 通用图片效果 end */

  /* 注册pidtt start */
  // 获取URL参数
  function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return decodeURI(r[2]);
    }
    return null;
  }
  function setcookie_pidtt() {
    var pidVal = getQueryString('pid') || '';
    if (!pidVal) return false;
    JSCookie.set('pidtt', pidVal, { path: '/', domain: 'popcmf.com' });
    var searchParams = new URLSearchParams(location.search);
    searchParams.delete('pid');
    var searchParamsStr = searchParams.toString();
    history.replaceState(null, '', location.origin + location.pathname + (searchParamsStr ? '?' + searchParamsStr : ''));
  };

  setcookie_pidtt();
  /* 注册pidtt end */

  /*聊天咨询  start */
  var loginStatus = ""; // prev-售前, after-售后
  window.showWPA = function (type) {
    loginStatus = type;
    var $QQ_Consult = loginStatus == "after" ? 1 : 1;
    var src = "/home/wpa/?t=" + $QQ_Consult;
    $(".js-wpa-iframe").show().find("iframe").attr("src", src);
  };
  // 在线qq
  $("body")
    .on("click", ".js-contact-qq-btn", function () {
      // var type = $(this).attr("data-logintype") || "prev";
      // showWPA(type);
      // $(".js--contact-aff-btn").trigger("click");
      $(".embed-icon-default").trigger("click");
    })
    .on("click", ".js--contact-aff-btn", function () {
      $(".embed-icon-default").trigger("click");
    });
  /*聊天咨询  end */

  /*header效果 start */
  // 搜索框效果
  $("[js_search_bigscreen]").on("click", ".default_show", function () {
    $(this).removeClass("show");
    $(this).siblings(".focus_show").addClass("show");
    $(this).siblings(".focus_show").find("input").trigger("focus");
  });
  $("[js_search_smallscreen]").on("click", function () {
    $(this).find(".focus_search").addClass("focus_search_show");
    $(this).find(".search_input").trigger("focus");
  });
  $("body")
    .on("click", function (e) {
      var bigInputObj = $("[js_search_bigscreen]").find(".search_input");
      var smallInputObj = $("[js_search_smallscreen]").find(".search_input");
      bigInputObj.val("");
      smallInputObj.val("");
      bigInputObj.parent().removeClass("show");
      bigInputObj.parent().siblings(".default_show").addClass("show");
      smallInputObj.parent().removeClass("focus_search_show");
    })
    .on("click", "[js_header_search]", function (e) {
      e.stopPropagation();
    });
  // 全站搜索
  $("[js_header_search]")
    .on("click", ".search_btn", function () {
      var inputObj = $(this).siblings(".search_input");
      searchJump(inputObj);
    })
    .on("keypress", ".search_input", function (event) {
      if (event.key == "Enter") {
        searchJump($(this));
      }
    });
  function searchJump(obj) {
    var val = obj.val();
    var jsonObj  = {
      location_name:'全站搜索',
      operate_name:val
    }
    gio("track", "allsearch_result_click", jsonObj);
    if (val == "") {
      return false;
    }
    var url = "/search/?key=" + val;
    window.open(url);
  }
  // 主导航
  $("[js_v_header_list]>div")
    .on("mouseenter", function () {
      $(this).find(".v_header_downlist").stop().slideDown(300);
    })
    .on("mouseleave", function () {
      $(this).find(".v_header_downlist").stop().slideUp(300);
    });
  // 汉堡包
  $("[js_h_other_web]")
    .on("mouseenter", function () {
      $(this).find(".h_web_downlist").stop().slideDown(300);
    })
    .on("mouseleave", function () {
      $(this).find(".h_web_downlist").stop().slideUp(300);
    });
  /*header搜索框效果 end */

  /*页面滚动  start */
  $(window).on("scroll", function () {
    var scrollTop = $(this).scrollTop();
    if (scrollTop > 50) {
      $("[js_scroll_header_nav]").show();
      $("[js_go_back_box]").show();
    } else {
      $("[js_scroll_header_nav]").hide();
      $("[js_go_back_box]").hide();
    }
  });
  $("[js_go_back_box]").on("click", function () {
    $(window).scrollTop(0);
  });
  /*页面滚动  end */

  window.showTips = function (msg, time, type) {
    time = time ? time : 2000;
    if (type) {
      $(".common-tips .content-view i").addClass("cur");
    }
    $(".common-tips .content-view span").html(msg);

    if ($(".common-tips").hasClass("show")) {
      return;
    }
    $(".common-tips").addClass("show");

    var timer = setTimeout(function () {
      $(".common-tips").removeClass("show");
      clearTimeout(timer);
    }, time);
  };

  /*翻页跳转start */
  var goto = function (event) {
    var is_click = false;
    if (event.data) {
      is_click = event.data.e == "click";
    }
    if (event.which == 13 || is_click) {
      //获取需要跳转到的页码
      var page = $("#J_GoPage").val();
      page = parseInt(page);
      if (page <= 0) {
        return false;
      }
      //获取总页数pageCount
      var pageCount = parseInt($("#goBtn").data("totalpage"));
      if (page >= pageCount) {
        page = pageCount;
      }
      //获取需要跳转到的URL
      var url = window.location.pathname;
      var search = window.location.search;
      if (search.indexOf("?") === -1) {
        search = search.replace(/\/$/, "") + "?page=" + page;
      } else {
        if (search.indexOf("page=") != -1) {
          search = search
            .replace(/\/$/, "")
            .replace(/page=([^&]*)/gi, "page=" + page);
        } else {
          search = search.replace(/\/$/, "") + "&page=" + page;
        }
      }
      if (isNaN(page)) {
        return false;
      }
      window.location.href = url + search;
    }
  };

  $("body").on("click", "#goBtn", { e: "click" }, goto);
  $("body").on("keypress", "#J_GoPage", goto);

  /* 收藏start */
  var isLoading = false;
  $("body").on("click", ".js-collect-click", function (event) {
    event.stopPropagation();
    event.preventDefault();
    if (isLoading) {
      return;
    }
    isLoading = true;
    if (P_UserType == "TOURIST" || P_UserType == "GENERAL") {
      $(".js-list-tips").show();
      isLoading = false;
      return;
    }
    var btn_element = $(this);
    var pid = $(this).data("id");
    var t = $(this).data("t");
    var parm = { id: pid, t: t };
    var hasCur = $(this).hasClass("cur");
    var is_sub = $(this).hasClass("sub-list"); //是否是二级；列表页

    if (!hasCur) {
      parm["action"] = "add";
    } else {
      parm["action"] = "cancel";
    }
    var userCollection = $(this).hasClass("userCollection"); // 是否是个人中心的收藏
    $.ajax({
      method: "post",
      dataType: "json",
      url: "/member/collect?" + Math.random(),
      data: parm,
      success: function (data) {
        isLoading = false;
        showTips(data.msg, 2000, "success");
        if (data.code == 200) {
          if (userCollection) {
            const timer = setTimeout(() => {
              location.reload();
              clearTimeout(timer);
            }, 2000);
          } else {
            if (hasCur) {
              btn_element.removeClass("cur");
            } else {
              if(btn_element.hasClass('gio-click')) {
                var json = JSON.parse(btn_element.attr("data-gio-imp-attrs"))
                gio("track", "report_collect", json);
              }
              btn_element.addClass("cur");
            }
          }

          if (is_sub) {
            var span_ele = $(".js-collect-click span");
            hasCur ? span_ele.html("收藏") : span_ele.html("已收藏");
          }
        } else {
          showTips(data.msg);
        }
      },
      error: function (err) {
        isLoading = false;
      },
    });
    return;
  });
  /* 收藏end */

  /*公共弹窗关闭 start*/
  $("body").on("click", ".common-view .js-close-alert", function () {
    $(".common-view").hide();
    $("html,body").css("overflow", "auto");
  });
  $("body").on("click", ".list-alert .js-close-alert", function () {
    $(".list-alert").hide();
    $("html,body").css("overflow", "auto");
  });
  $("body").on("click", ".detail-alert .js-close-alert", function () {
    $(".detail-alert").hide();
    $("html,body").css("overflow", "auto");
  });
  // 留资成功关闭
  $("[js_free_trial_success]").on("click", ".close_btn", function () {
    $("[js_free_trial_success]").hide();
  });

  /*公共弹窗关闭 end*/

  /*偏好设置 start */
  var userLikeStr = "";
  var userLikeArr = [];
  var islike = false;
  $("[js_userlike_container]")
    .on("click", ".js-item-click .item-view", function () {
      var type = $(this).data("type");
      if (userLikeArr.indexOf(type) == -1) {
        $(this).addClass("cur");
        userLikeArr.push(type);
      } else {
        $(this).removeClass("cur");
        userLikeArr.splice(userLikeArr.indexOf(type), 1);
      }
      userLikeStr = userLikeArr.join(",");
    })
    .on("click", ".js-category-submit", function () {
      if (userLikeStr == "") {
        showTips("请选择您主要关注的类目");
        return false;
      }
      if (islike) return;
      islike = true;
      $.ajax({
        url: "/home/setUserLike",
        type: "POST",
        dataType: "json",
        data: { user_like: userLikeStr },
        success: function () {
          $("[js_userlike_container]").hide();
          islike = false;
        },
      });
    });
  /*偏好设置 end */

  /*信息反馈 start*/
  $(".js_feedback_info").on("click", function () {
    $("[js_feedback_container]").show();
  });
  $("[js_feedback_container]")
    .on("input", ".textarea_input", function () {
      limitMaxLength($(this), 200);
    })
    .on("click", "[js_feedback_close]", function () {
      $("[js_feedback_container]").hide();
    })
    .on("click", "[js_feedback_submit]", function () {
      var infoTxt = $("[js_feedback_container]").find(".textarea_input").val();
      if (infoTxt == "") {
        showTips("请输入您的意见或建议！");
        return false;
      }
      $.ajax({
        url: "/member/feedback/",
        type: "POST",
        dataType: "json",
        data: { content: infoTxt },
        success: function (data) {
          if (data.code == 200) {
            showTips("感谢您的反馈！", 2000, 1);
            $("[js_feedback_container]").hide();
          } else {
            showTips(data.msg);
          }
        },
      });
    });
  // 限制字符长度
  function limitMaxLength(obj, count) {
    var inputText = obj.val();
    var limitObj = obj.siblings(".js_total_count");
    limitObj.text(`${inputText.length} / ${count}`);
  }
  /*信息反馈 end*/

  /* 趋势站PID复用 start*/
  $(".js_go_other_web").on("click", function (e) {
    var url = $(this).data('href') || $(this).attr('href') || '';
    if (!url || url.startsWith('javascript:')) return;
    e.preventDefault();
    var pid = JSCookie.get('pidtt');
    var jumpUrl = url;
    if (pid) {
      if (url.indexOf('?') != -1) {
        jumpUrl += '&' + (pid ? 'pid=' + pid : '');
      } else {
        jumpUrl += '?' + (pid ? 'pid=' + pid : '');
      }
    }
    window.open(jumpUrl)
  });
  /* 趋势站PID复用 end*/

  // AI智绘详情页面跳转
  $(".js_go_aigc_web").on("click", function () {
    var url = $(this).data('href') || '';
    if (url == "") {
      return false;
    }
    var popUser = JSCookie.get('POP_USER');
    var pid = JSCookie.get('pidtt');
    var jumpUrl;
    if (url.indexOf('?') != -1) {
      jumpUrl = url + (popUser ? '&popuser=' + popUser : '') + (pid ? '&pid=' + pid : '');
    } else {
      jumpUrl = url + (popUser ? '?popuser=' + popUser + (pid ? '&pid=' + pid : '')  : '' + (pid ? '?pid=' + pid : ''));
    }
    window.open(jumpUrl)
  });

  // 详情无权限页标签跳转
  $("body").on("click", ".js-allsearch-label",function() {
    var txt = $(this).text();
    var url = "/search/?key=" + txt;
    window.open(url);
  })




  // 首页协议倒计时
  // 设置倒计时的总时间（秒）
  let countdownTime = 5;

  // 显示倒计时的元素
  const countdownElement = document.querySelector('.homeLayer .content .bottom .btn .time');
  const homeLayerElement = document.querySelector('.home_shadow_black');
  const homeLayerBtnElement = homeLayerElement.querySelector('.btn');
  // 更新倒计时的函数
  function updateCountdown() {
    countdownTime--; // 减少倒计时时间

    // 当倒计时结束时，清除定时器
    if (countdownTime < 1) {
      clearInterval(countdownInterval);
      homeLayerBtnElement.innerHTML = '我已阅读并同意';
      homeLayerBtnElement.classList.add('confirm');
    }
    countdownElement.textContent = countdownTime; // 更新显示的倒计时数字
  }

  // 设置定时器，每1000毫秒（1秒）更新一次倒计时
  let countdownInterval = null

  // 检查是否是第一次加载页面
  function isFirstLoad() {
    var is_first = localStorage.getItem('is_first_login')
    // 检查localStorage中是否有'firstLoad'这个键
    if ( is_first == '1') {
      // 如果没有，说明是第一次加载，设置标志并返回true
      showProcotol()
      return true;
    } else {
      // 如果有，说明不是第一次加载，返回false
      return false;
    }
  }
  isFirstLoad()
  function showProcotol(){
    homeLayerElement.classList.add('show')
    countdownInterval = setInterval(updateCountdown, 1000);
    // localStorage.removeItem('is_first_login')
  }
  var homeLayerBtnElementLoading = false;
  homeLayerBtnElement.onclick = function () {
    if (homeLayerBtnElementLoading || countdownTime > 0 || !homeLayerBtnElement.classList.contains('confirm')) return;
    homeLayerBtnElementLoading = true;
    $.ajax({
      url: '//member.pop136.com/login/confirmAgreement',
      type: 'get',
      data:{
        website: 14,
        jwt: JSCookie.get('POP_USER'),
      },
      complete: function() {
        homeLayerBtnElementLoading = false;
        homeLayerElement.classList.remove('show');
        localStorage.removeItem('is_first_login');
      }
    })
  }

  function sem_ck(){
    var bdVal =  getQueryString('bd_vid') || '';
    var qhcVal = getQueryString('qhclickid') || '';
    var mscVal = getQueryString('msclkid') || '';
    var parm = {}
    if(bdVal){
      bdVal = bdVal.replace(/[\/#]*$/, '')
      bdVal = 'bd_vid|' + bdVal
      parm['bd_vid'] = bdVal
    }
    if(qhcVal){
      qhcVal = qhcVal.replace(/[\/#]*$/, '')
      qhcVal = 'qhclickid|' + qhcVal
      parm['qhclickid'] = qhcVal
    }
    if(mscVal){
      mscVal = mscVal.replace(/[\/#]*$/, '')
      mscVal = 'msclkid|' + mscVal
      parm['msclkid'] = mscVal
    }
    var sem_parm = JSCookie.get('sem_key') == null ? {} : JSON.parse(JSCookie.get('sem_key'));
    var s_key = sem_parm['bd_vid'] ? sem_parm['bd_vid'] : sem_parm['qhclickid'] ? sem_parm['qhclickid'] : sem_parm['msclkid'] ? sem_parm['msclkid'] : ''
    if(bdVal && bdVal != sem_parm['bd_vid']){
      JSCookie.set('sem_url', window.location.href,{ path: '/', domain: 'popcmf.com' });
    }else if(qhcVal && qhcVal != sem_parm['qhclickid']){
      JSCookie.set('sem_url', window.location.href,{ path: '/', domain: 'popcmf.com' });
    }else if(mscVal && mscVal != sem_parm['msclkid']){
      JSCookie.set('sem_url', window.location.href,{ path: '/', domain: 'popcmf.com' });
  }

    if(Object.keys(parm).length > 0){
      JSCookie.set('sem_key', JSON.stringify(parm), { path: '/', domain: 'popcmf.com' });
    }
}
 //获取URL参数
 function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
 }
sem_ck()

  /* 风险提示 */
  var riskMsgWrapEl = $('.js-risk-msg-wrap');
  if (riskMsgWrapEl.length > 0) {
    var riskListWrap = riskMsgWrapEl.children().filter('div');
    var itemHeight = riskMsgWrapEl.height();
    var riskLenght = riskListWrap.children().length;
    var riskIndex = 0;
    var riskFirstClone = null;
    function riskScrollInit() {
      clearInterval(riskScrollInit.timer);
      if (riskFirstClone) riskFirstClone.remove();
      var riskListEls = riskListWrap.children();
      riskLenght = riskListEls.length;
      var isAlone = riskLenght <= 1;
      if (isAlone || riskIndex > riskLenght - 1) {
        riskIndex = 0;
        riskListWrap.stop().css({ top: 0 });
        if (isAlone) return;
      }
      riskFirstClone = riskListEls.first().clone();
      riskListWrap.append(riskFirstClone);
      riskScrollInit.timer = setInterval(function() {
        riskIndex++;
        if (riskIndex > riskLenght - 1) riskIndex = 0;
        riskListWrap.animate({ top: -itemHeight * (riskIndex + (riskIndex === 0 ? riskLenght : 0)) }, 300, function() {
          if (riskIndex === 0) riskListWrap.stop().css({ top: 0 });
        });
      }, 5000);
    }
    if (riskLenght > 1) {
      riskScrollInit();
      riskMsgWrapEl.hover(function() {
        clearInterval(riskScrollInit.timer);
      }, function() {
        riskScrollInit();
      });
    }
    riskMsgWrapEl.on('click', '.js-risk-close', function() {
      var activeItem = riskListWrap.children().eq(riskIndex);
      var id = activeItem.attr('data-id');
      if (riskLenght > 1) {
        activeItem.remove();
        riskScrollInit();
      } else {
        riskMsgWrapEl.remove();
      }
      $.ajax({ url: '//member.pop136.com/confirmTip/?id=' + id });
    });
  }


 
  /************* 导航搜素 *****************/ 

  // 头部搜索
  var searchMaxLen = 10;
  var historySearchMaxLen = 5;
  var searchFocusCount = -1;
  var historySearchData = {};
  var hotSearchData = [];
  var recommendSearchData = [];
  var searchIpt = $('.js_search_ipt');
  var searchBtn = $('.js_search_btn');
  var searchOptBox = $('.js_search_opt_box');
  var searchOptBoxWarp = $('.js_search_opt_box_warp');
  var searchType = 'all'
  $(document).on('click', function (e) {

    let pic = document.querySelector('.search_ipt_box .v_search_pic_btn')
    if((pic && pic.contains(e.target))  || e.target.classList.contains('upload-img')){
     
    }else{
        hideSearchOptBox();
    }
    
  })
  $(window).on('scroll', function () {
    hideSearchOptBox();
  })
  $('.js_search_ipt_box').on('click', function (e) {
    var e = e || window.event;
    e.stopPropagation();
    $(this).siblings('.js_search_opt_box_warp').show().find('.js_search_ipt').focus();
    // searchOptBoxWarp.show();
    // searchOptBoxWarp.find('.js_search_ipt').focus();
  })
  //栏目切换
  $(".js-switch-search>a").on("click", function (e) {
    e.stopPropagation()
    searchType = $(this).data('type') || '';
    $(".js-switch-search>a").removeClass('on');
    $(".js-switch-search>a").each((index, item)=>{
      if($(item).data('type') == searchType){
        $(item).addClass('on')
      }
    })
    $(this).addClass('on').siblings().removeClass('on');
    if(searchType == 'all'){
      $('.js-switch-search .nav_bg').removeClass('on')
    }else{
      $('.js-switch-search .nav_bg').addClass('on')
    }

    placeholderStart()
   
  });
  //合辑和单张切换
  $("body").on("click", ".product-filter .js_dis_click", function (e){
    var url = $(this).attr('data-link');
    let key = $('#global_search_value').attr('data-key');
    let path = $('#global_search_value').attr('data-path');
    
    url = url.includes('popcmf.com') ? url : window.location.origin + url;
    let urlObj = new URL(url);
    let params = new URLSearchParams(urlObj.search);

    if(key && key.length > 0) {
      params.append('key', key);
    }
     if(path && path.length > 0) {
      params.append('path', key);
    }

    urlObj.search = params.toString();
    url = urlObj.toString();
    window.open(url, "_self");



  }); 


  function getSearchType(){
      return $('.js-switch-search a.on').attr('data-type') || 'all';
  }
  // 搜索按钮
  searchBtn.on("click", function (e) {
    var e = e || window.event;
    e.stopPropagation();
  
    let val = $(this).siblings('.js-all-search-area').val();
    if(getSearchType() == 'all' && nav_img_url.length == 0 && val.trim().length == 0){

      val = $(this).siblings('.js-all-search-area').attr('data-default')
    }

    if(getSearchType() == 'column' && nav_img_url.length == 0 && val.trim().length == 0){
      return;
    }

    searchVal(val, getSearchType());
   
  });
  searchIpt.on('click', function (e) {
    var e = e || window.event;
    e.stopPropagation();
  }).on('focus', function (e) {
    var e = e || window.event;
    e.stopPropagation();
    var val = $(this).val();
    showSearchOptBox(val,$(this));
    $(this).autocomplete("search")
  }).on('blur', function () {
   
  }).on('input', function () {
    // var val = $(this).val();
    // showSearchOptBox(val,$(this));
    // placeholderStart()
  }).on('keypress', function (e) {
    var e = e || window.event;
    var val = $(this).val();
    const type = $(this).data('type')
    if (e.keyCode === 13) {
      e.stopPropagation();
      if(getSearchType() == 'all' && nav_img_url.length == 0 && val.trim().length == 0){
        val = nav_input_ele.attr('data-default')
      }
      searchVal(val, type);
      return false;
    }
  }).on('keyup', function (e) {
    var listDown = $(this).parent().siblings('.js_search_opt_box');
    var isShow = listDown.find('.association_search').is(":visible");
    if (!isShow) return;
    if (e.keyCode === 40) { // 下
      e.stopPropagation();
      searchFocusCount++;
      if (searchFocusCount > 9) {
        searchFocusCount = 0;
      }
      listDown.find('.association_search .item').removeClass('on').eq(searchFocusCount).addClass('on');
    } else if (e.keyCode === 38) { // 上
      e.stopPropagation();
      searchFocusCount--;
      if (searchFocusCount < 0) {
        searchFocusCount = 9;
      }
      listDown.find('.association_search .item').removeClass('on').eq(searchFocusCount).addClass('on');
    } else if (e.keyCode === 13) { // 回车
      e.stopPropagation();
      if (searchFocusCount === -1) {
        return false;
      } else {
        listDown.find('.association_search .item').eq(searchFocusCount).trigger('click');
      }
      return false;
    }
  })
  searchOptBoxWarp.on('click', function (e) {
    var e = e || window.event;
    e.stopPropagation();
  })
  searchOptBox.on('click', function (e) {
    var e = e || window.event;
    e.stopPropagation();
  })
  // 移动
  searchOptBox.find('.association_search').on('mouseenter', '.item', function () { // 移入
    searchFocusCount = $(this).index();
    $(this).addClass('on').siblings().removeClass('on');
  }).on('mouseleave', '.item', function () { // 移出
    searchFocusCount = -1;
    $(this).removeClass('on').siblings().removeClass('on');
  })

   //导航下拉点击跳转搜索 
  searchOptBox.on('click', '.item', function (e) { // 搜索
  e.stopPropagation();
  var val = $(this).attr('data-label');
  var newVal = this.innerText;
  var ediUrl = $(this).data('ediurl');
   clearInterval(placeTimer)
 $('.v_search_clear_btn').addClass("show")
  if (ediUrl) {
    searchIpt.blur();
    searchHis(val);
    hideSearchOptBox();
    renderSearchHistory('add', val, ediUrl);
    window.open(ediUrl);
  } else {
    searchIpt.val(newVal);
    searchVal(newVal);
  }
 
  return false;
  }).on('click', '.clear_history', function (e) { // 清除
    e.stopPropagation();
    searchIpt.focus();
    renderSearchHistory('clear');
    return false;
  })
  // 删除单个搜索历史
  searchOptBox.on('click', '.history_search .item .del', function (e) {
    e.stopPropagation();
    var val = $(this).attr('data-label');
    renderSearchHistory('del', val);
  })
  // 显示搜索下拉
  function showSearchOptBox(val,obj) {
    searchFocusCount = -1;
    if (val) {
      searchOptBox.find('.init_search').hide();
      searchOptBox.find('.association_search').hide();
      searchOptBox.hide();
    } else {
      searchOptBox.find('.association_search').hide();
      // searchOptBox.find('.init_search').show();
      obj.parent('.search_ipt_box').siblings('.js_search_opt_box').find('.init_search').show()
      renderSearchHistory();
    }
    initHotSearchData(val,obj);
  }
  // 隐藏搜索下拉
  function hideSearchOptBox() {
    searchOptBox.find('.association_search').hide().find('.item').removeClass('on');
    // searchOptBox.find('.init_search').show();
    searchOptBox.hide();
    searchOptBoxWarp.hide();
    searchIpt.blur();
  }
    // 热门搜素
  function httpRequestHotSearch() {
      var hotStr = ''; 
      $.ajax({
          url: '/aisearch/hotSearch/',
          type: 'POST',
          dataType: 'json',
        
          success: function (data) {
          if(data.code == 0){
              for (var i = 0; i < data.data.length; i++) {
                  let key = data.data[i] || ''
                  hotStr += '<span class="item" data-label="' + (key || '暂无数据') + '">' + (key || '暂无数据') + '</span>';           
              }
              if (hotStr.length > 0) {
                searchOptBox.find('.hot_search .item_box').html(hotStr);
              }
          }   
          } ,
          error: function(){
          
          }
        })

  }
  httpRequestHotSearch();
  // 猜你可能感兴趣
  function httpRequestGuessYouLike() {
      $.ajax({
          url: '/aisearch/reportTop/',
          type: 'POST',
          dataType: 'json',
        
          success: function (data) {
          if(data.code == 0){
              let parm = data.data[0]
              if(parm){
                  $('.search_opt_box .recommend_search').show()
                  $('.search_opt_box .recommend_search .recommend-view a').attr("href",parm.detail_url || '')
                  $('.search_opt_box .recommend_search .recommend-view img').attr("src",parm.cover || '')
                  $('.search_opt_box .recommend_search .right-view .title').html(parm.title || '')
              }
            
          }  
          } ,
          error: function(){
          
          }
        })

  }
  httpRequestGuessYouLike();

  function setToLocalStorage(key_name,parm) {
    localStorage.setItem(key_name, JSON.stringify(parm));
  }
  function getFromLocalStorage(key_name) {
      var val=localStorage.getItem(key_name);
      if(val==="undefined"){
          return "undefined";
      }else if(typeof val === "number"){
          return val;
      }else if(val){
          try{
              return JSON.parse(val)?JSON.parse(val):"";
          }catch(e){
              return eval('('+val+')');
          }
      }
  }
  function delLocalStorage() {
    localStorage.removeItem(key_name);
  }

  // 初始热门/推荐/搜索数据
  function initHotSearchData(val,obj) {
    if (val && val.length > 0) {
    
    } else {
   
      obj.parent('.search_ipt_box').siblings('.js_search_opt_box').show()

      // renderHotSearchData(val);
    }
  }
  // 渲染热门/搜索数据
  function renderHotSearchData(val) {
    if (val) {
      // 搜索
      var hisStr = '';
      for (var i = 0; i < searchMaxLen; i++) {
        if (historySearchData[val] && historySearchData[val][i] && historySearchData[val][i].keyword) {
          hisStr += '<span class="item" data-label="' + historySearchData[val][i].keyword + '">' + historySearchData[val][i].keyword + '</span>';
        }
      }
      searchOptBox.find('.association_search .item_box').html(hisStr);
      if (hisStr === '') {
        searchOptBox.hide();
      }
    } else {
    
    }
  }
  // 渲染历史数据/操作
  function renderSearchHistory(type, val, url) {
    var history = getFromLocalStorage('search-history') || [];
    if (history != '' && typeof history[0] == 'string') {
      for (var k = 0; k < history.length; k++) {
        history[k] = {
          name: history[k]
        }
      }
    }
    if (type === 'del' && val) {
      var idx = -1;
      for (var i = 0; i < history.length; i++) {
        if (history[i].name === String(val)) {
          idx = i;
          break;
        }
      }
      if (idx != -1) {
        history.splice(idx, 1);
        setToLocalStorage('search-history', history);
      }
    } else if (type === 'clear') {
      history = [];
      setToLocalStorage('search-history', history);
    } else if (type === 'add' && val) {
      var idx = -1;
      for (var i = 0; i < history.length; i++) {
        if (history[i].name === String(val)) {
          idx = i;
          break;
        }
      }
      if (idx != -1) {
        history.splice(idx, 1);
      }
      var newobj = { name: String(val) };
      if (url) {
        newobj.url = url
      }
      history.unshift(newobj);
      if (history.length > historySearchMaxLen) {
        history.pop();
      }
      setToLocalStorage('search-history', history);
    }
    if (type) { // 更新热门
      renderHotSearchData();
    }
    var historyStr = '';
    history.forEach(function (item) {
      if (item.url) {
        historyStr += '<div class="item" data-label="' + item.name + '" data-ediurl="' + item.url + '"><span><i class="ai_nav_icon icon"></i><span>' + item.name  + '</span><i class="ai_nav_icon del" data-label="' + item.name + '"></i></span></div>';
      } else {
        historyStr += '<div class="item" data-label="' + item.name + '"><span><i class="ai_nav_icon icon"></i><span>' + item.name + '</span><i class="ai_nav_icon del" data-label="' + item.name + '"></i></span></div>';
      }
    })
    searchOptBox.find('.history_search .item_box').html(historyStr);
    if (historyStr) {
      searchOptBox.find('.history_search').show();
    } else {
      searchOptBox.find('.history_search').hide();
    }
  }
  // 搜索记录
  function searchHis(val) {
    // $.ajax({
    //   url: '/suggest/',
    //   method: 'post',
    //   data: {
    //     keyword: val
    //   }
    // })
  }
  // 搜索
  function searchVal(val, type) {
    // const _type = type || searchType
 
    let _type = getSearchType()

    searchIpt.blur();
    searchHis(val);
    hideSearchOptBox();
    renderSearchHistory('add', val);
    let col = $('#global_search_value').attr('data-col')
     let tim = 3
    // var newBrandUrl = encodeURI(brandUrl);
    // 当关键词为空时去掉keywrod=
    if (_type == 'all') {
    
      // window.open("/style/all/?keyword=" + encodeURIComponent(val));
      let is_ai = (nav_img_url && nav_img_url.length > 0 || window.location.pathname.includes('/aisearch/'))
      let url = is_ai ? '/aisearch/tab_1/' : '/search/'

    
       if(col == 702){
        
          tim = 2
          url = is_ai ? '/aisearch/tab_2/' : '/search/col_702/'
        }
        if(col == 753){
   
          tim = 2
          url = is_ai ? '/aisearch/tab_3/' : '/search/col_753/'
        }


      openSearchResultWithType(url,'new',tim,val)

    } else {
      if(nav_img_url && nav_img_url.length > 0){
        let url = '/aisearch/column/tab_1/'
       
       
        if(col == 702){
          url = '/aisearch/column/tab_2/'
          tim = 2
        }
        if(col == 753){
          url = '/aisearch/column/tab_3/'
          tim = 2
        }
        url = url + '?col=' + col 
       

        openSearchResultWithType(url,'new',tim,val)

      }else{
        editKeyJump(val)
      }
      
    }
    // placeholderStop()
  }
  function editKeyJump(val) {
    // var val = encodeURIComponent(encodeURIComponent(val));
    // var val = encodeURIComponent(val);
    // var url = location.href;
    // var url_search = location.search;
    // var pathname = location.pathname;
    // if (url_search != "") {
    //   // 如果存在分页
    //   if (url_search.indexOf("?page=") != -1) {
    //     url_search = url_search.replace(/\?page=([^&]*)/gi, "");
    //   } else if (url_search.indexOf("&page=") != -1) {
    //     url_search = url_search.replace(/\&page=([^&]*)/gi, "");
    //   }
    //   if (url_search.indexOf("key=") != -1) {
    //     url_search = url_search.replace(/key=([^&]*)/gi, "key=" + val);
    //   } else {
    //     if (url_search.indexOf("?") != -1) {
    //       url_search = url_search + "&key=" + val;
    //     } else {
    //       url_search = url_search + "?key=" + val;
    //     }

    //   }
    //   url = pathname + url_search;
    // } else {
    //   url = pathname + "?key=" + val;
    // }
    // location.href = url;

  
        let urlObj = new URL(window.location.href);
        let params = new URLSearchParams(urlObj.search);
        params.delete('aitag');
        params.delete('page');
        params.set('key', encodeURIComponent(val) );
        urlObj.search = params.toString();
        window.open(urlObj.toString(), "_self");


  }
  $("body").on("click",".js-style-title",function(){
    let title = $(this).attr('data-str')
    let url = window.location.pathname
    let key = $('#global_search_value').attr('data-key')
    if(key){
      key = key + ' ' + title
    }else{
      key = title

    }

    openSearchResultWithType(url,'','',key)


  })



  function openSearchResultWithType(url,type,tim,val) {
    var urlSearchParams = new URLSearchParams(window.location.search);

    // let key = $('.js-nav-search-area').val() ? $('.js-nav-search-area').val() : decodeURIComponent(decodeURIComponent(urlSearchParams.get('keyword') || '').replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25'))
    let key = val ? decodeURIComponent(val || '').replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25') : ''
    if(val == 'key_type'){
        key = decodeURIComponent(decodeURIComponent(urlSearchParams.get('key') || '').replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25'))
    }    

    let aiTag = decodeURIComponent(urlSearchParams.get('aitag') || '')


    if(getSearchType() == 'all' && nav_img_url.length > 0 && url.includes('/aisearch/tab_1/')){
      url = url.replace('tab_1','tab_2')
    }

    tim = 3
    if(url.includes('/aisearch/') ){
      let col = $('#global_search_value').attr('data-col')
      if(col == '703' || col == '753' || url.includes('/tab_2/') || url.includes('/tab_3/')){
        tim = 2
      }
    }else{
      tim =  ''
    }
   


    url = url.includes('popcmf.com') ? url : window.location.origin + url;
    let urlObj = new URL(url);
    let params = new URLSearchParams(urlObj.search);

    // 添加参数
    if(nav_img_url && nav_img_url.length > 0){
        params.append('path', encodeURIComponent(nav_img_url) );
    }else{
        params.delete('path');
    }
    if(key && key.length > 0){
        params.append('key', encodeURIComponent(decodeURIComponent(key)) );
    }else{
        params.delete('key');
    }
    // if(aiTag && aiTag.length > 0){
    //     params.append('aitag', encodeURIComponent(aiTag) );
    // }else{
        params.delete('aitag');
    // }

    if($('#global_search_value').attr('data-sear')){
    params.append('sear', '1' );
    }else{
    params.delete('sear'); 
    }


    if(tim){
        params.append('tim', encodeURIComponent(tim) );
    }else{
        params.delete('tim');
    }



    urlObj.search = params.toString();

    url = urlObj.toString();
    gioClick(params,window.location.pathname)

  
    if(window.location.pathname.includes('/aisearch/') || window.location.pathname.includes('/search/') || getSearchType() == 'column'){
      type = ''
    }
    if(!window.location.pathname.includes('/aisearch/') && !window.location.pathname.includes('/search/') && getSearchType() == 'all'){
      type = 'new'
    }
    type == 'new' ? window.open(url, "_blank") : window.open(url, "_self");
  }


  /* 占位文字start */ 
  var urlSearchParams = new URLSearchParams(window.location.search);
  let nav_img_url = decodeURIComponent(urlSearchParams.get('path') || '')

  var placeIndex = 1
  var placeArr = ['试试搜索“26/27秋冬”','小家电','极简风 汽车','大家都在搜“几何线条”']
  var searchKeyArr = ['26/27秋冬','小家电','极简风 汽车','几何线条']
  let nav_input_ele = $(".js-all-search-area")  
  let placeTimer = null
  // 占位文字滚动
  function placeInit(isInit){

    placeIndex++;
    if (placeIndex > placeArr.length - 1){
        placeIndex = 0;
    } 
    
      var val = searchKeyArr[placeIndex];
      nav_input_ele.attr("data-default", val);
      nav_input_ele.animate(
        { 
          opacity: 0,
        },
        isInit ? 0 : 300,
        function () {
          nav_input_ele.attr("placeholder", placeArr[placeIndex]);
        //   nav_input_ele.attr('data-place',placeArr[placeIndex])
          nav_input_ele.stop().animate(
            {
              opacity: 1,
            },
            300
          );
        }
      );

  }
  function placeholderStart(){

    if(getSearchType() == 'column'){
       clearInterval(placeTimer)
      nav_input_ele.attr("placeholder","输入关键词在当前栏目搜索")
     
      return
    }
   
    if(nav_img_url && nav_img_url.length > 0 ){
      clearInterval(placeTimer)
      nav_input_ele.attr("placeholder","您还可以继续追加描述")
      return
    }

    if(nav_input_ele.length == 0){
      return
    }
   
    let key = $('#global_search_value').attr('data-key') || ''

    if($('.js_v_search_clear_btn').css("display") == "none" && (!key  || key.length == 0) && (!nav_img_url || nav_img_url.length == 0)){
      placeInit(true)
      clearInterval(placeTimer)
      placeTimer = setInterval(placeInit,3000)
    }else{
      placeholderStop()
    }

  }
  function placeholderStop(){
    if(nav_input_ele.length == 0){
        return
    }

    if(nav_img_url.length == 0 && nav_input_ele.val().length == 0 ){
      placeInit(true)
    }else{
      nav_input_ele.attr("placeholder","")
    }
    clearInterval(placeTimer)
  
    
  }

  function initPlaceholder(){

        if(nav_img_url && nav_img_url.length > 0 && !window.location.pathname.includes('/picmatch/similarpic') && !window.location.pathname.includes('/colortools/analyze')){
            $('.search_ipt_box .nav-pic-view').show()
            $('.search_ipt_box .nav-pic-view .pic-view .pic-loading').hide()
            $('.search_ipt_box .nav-pic-view .pic-view img').attr('src',nav_img_url)
        }else{
            $('.search_ipt_box .nav-pic-view').hide()
        }

        let key = $('#global_search_value').attr('data-key') ?? '' 
        let tag = $('#global_search_value').attr('data-tag') ?? ''


        let word = key 
        if(tag && tag.length > 0){
            word = word + ' ' + tag

        }
    
        if(word && word.length > 0 && word != ' '){
            placeholderStop()
            clearTimeout(placeTimer)
            $('.js_search_ipt').val(word)
            showClearBtn()
        }

  }
  initPlaceholder()
  placeholderStart()


  $(document).ready(function() {
    $('.js_search_ipt').on('input', function() {
      // 当 input 的值发生变化时触发
      var inputValue = $(this).val();
      showClearBtn()
      showSearchOptBox(inputValue,$(this));
      if (inputValue.trim() === '') {
        placeholderStart()
      } else {
        clearInterval(placeTimer)
        placeholderStop()
      }
    
    });
  });
  $('body').on("click",".v_search_clear_btn",function(){
    $('.js_search_ipt').val('')
    nav_img_url = ''
    $(this).hide()
    nav_pic_view_ele.hide()
    placeholderStart()
  })

  if($('.js_search_ipt').length != 0){
      showClearBtn()
  }

  function showClearBtn(){
    let key =  $('.js_search_ipt').val()

    if((nav_img_url && nav_img_url.length > 0) || (key && key.length > 0) ){
      $('.v_search_clear_btn').addClass("show")
    }else{
      $('.v_search_clear_btn').removeClass("show")
    }

  }
  /* 占位文字end */ 

  /* 上传图片-start */ 

  var allowsuf1 = ['jpg', 'jpeg', 'png'];//允许上传格式
  $("#uploadNavImg").change(function () {
  nav_pic_loading_ele.show()
  var fileList;
  if ($(this)[0].files) {
    fileList = $(this)[0].files;
  } else {
    
  }
  if (fileList.length > 0) {
    var val = $(this).val();
    var fileSuf = val.substring(val.lastIndexOf('.') + 1, val.length);
    if (!_checkSuf(fileSuf, allowsuf1)) {
    
      timingNavLayer('支持上传PNG、JPEG、JPG 格式，最大不超过5M')
      $("#uploadNavImg").val('');
      return;
    }
    
    var file = fileList[0];
    const maxSize = 5 * 1024 * 1024;
    if(file && file.size > maxSize){
      $("#uploadNavImg").val('');
      timingNavLayer('支持上传PNG、JPEG、JPG 格式，最大不超过5M')
      return
    }
    
    var formData = new FormData();
    formData.append('image', file);
    
    if(file){
      var reader = new FileReader();
      reader.onload = function(e){
        nav_pic_ele.attr('src',e.target.result)
        nav_pic_ele.show()
        nav_pic_view_ele.show()
        nav_pic_del_ele.hide()
      
        
      }
      reader.readAsDataURL(file);
    }

    uploadColorPicFunc(formData)

  }
  })
  //检查文件是否符合上传条件 
  let nav_pic_del_ele = $(".nav-pic-view .pic-view .pic-del")
  let nav_pic_view_ele = $(".nav-pic-view")
  let nav_pic_ele = $(".nav-pic-view .pic-view img")

  let nav_pic_loading_ele = $(".nav-pic-view .pic-view .pic-loading")

  // 图片删除按钮点击
  nav_pic_del_ele.on('click',function(e){
    e.stopPropagation();
    e.preventDefault();
    nav_pic_view_ele.hide()
    nav_img_url = ""
    placeholderStart()
  })
  // 上传图片
  let col = $('.js-data-hidden').attr('data-col')
  let colArr = ['allbrand','brand','graphic','china','designerbrand','ordermeeting','orderalbum','presscon','marketphoto','exhibition','topbrands'] 
  if( colArr.includes(col) || window.location.pathname.includes('/aisearch') || window.location.pathname.includes('/style') || window.location.pathname == '/'){
  $(".js_v_search_pic_btn").addClass('show')
  }
  let columid = $('#global_search_value').attr('data-col')
  
  if(columid == '700' || columid == '701' ){
  $(".js_v_search_pic_btn").removeClass('show')
  }
  var path_name = window.location.pathname
  if(path_name.includes('/aisearch/column/tab_1') && getSearchType() == 'column' ){
  $(".js_v_search_pic_btn").removeClass('show')
  }

  $(".js_v_search_pic_btn").on('click',function(e){
    e.stopPropagation();
    e.preventDefault();
    if( !$(e.target).hasClass('pic-btn') ){
        return
    }

    if(P_UserType == "TOURIST"){
     window.open('/login',"_self")
    }else{
      $("#uploadNavImg").trigger("click");
    }
  
  }).on("mouseenter",function(e){
    e.stopPropagation();
    $('.v_search_pic_btn .tips').addClass('show')
  }).on("mouseleave",function(e){
    e.stopPropagation();
    $('.v_search_pic_btn .tips').removeClass('show')

  })
  var allowsuf1 = ['jpg', 'jpeg', 'png'];//允许上传格式
  $("#uploadNavImg").change(function () {
  nav_pic_loading_ele.show()
  var fileList;
  if ($(this)[0].files) {
    fileList = $(this)[0].files;
  } else {
    
  }
  if (fileList.length > 0) {
    var val = $(this).val();
    var fileSuf = val.substring(val.lastIndexOf('.') + 1, val.length);
    if (!_checkSuf(fileSuf, allowsuf1)) {
    
      timingNavLayer('支持上传PNG、JPEG、JPG 格式，最大不超过5M')
      $("#uploadNavImg").val('');
      return;
    }
    
    var file = fileList[0];
    const maxSize = 5 * 1024 * 1024;
    if(file && file.size > maxSize){
      $("#uploadNavImg").val('');
      timingNavLayer('支持上传PNG、JPEG、JPG 格式，最大不超过5M')
      return
    }
    
    var formData = new FormData();
    formData.append('image', file);
    
    if(file){
      var reader = new FileReader();
      reader.onload = function(e){
        nav_pic_ele.attr('src',e.target.result)
        nav_pic_ele.show()
        nav_pic_view_ele.show()
        nav_pic_del_ele.hide()
      
        
      }
      reader.readAsDataURL(file);
    }

    uploadColorPicFunc(formData)

  }
  })
  function _checkSuf(fileSuf, suffixs) {
    for (var i = 0, j = suffixs.length; i < j; i++) {
      if (fileSuf.toLowerCase() == suffixs[i].toLowerCase()) {
        return true;
      }
    }
    return false;
  };
  function uploadColorPicFunc(formData) {
    $.ajax({
      url: '/aisearch/upload/' ,//+ Math.random()
      type: 'post',
      dataType: 'json',
      processData: false,
      contentType: false,
      data: formData,
      success: function (data) {
        if (data.code == 0) {
          nav_img_url = data.data['imgPath'];
          nav_pic_del_ele.show()
          placeholderStop()
          showClearBtn()
          $(".js_search_ipt").attr("placeholder","您还可以继续追加描述")
        } else{
          timingNavLayer(data.msg)
          nav_pic_view_ele.hide()
        }
        $("#uploadNavImg").val('');
        nav_pic_loading_ele.hide()
      },
      error: function (XMLHttpRequest, textStatus, errorThrown) {
        timingNavLayer('图片上传错误')
        $("#uploadNavImg").val('');
        nav_pic_loading_ele.hide()
        nav_pic_view_ele.hide()
      }
    })
  }
  // 定时弹层
  window.timingNavLayer = function (txt) {
    var sHtml = '<div class="common_timingNavlayer_fixed js_common_timingNavlayer_fixed"><span><i></i>' + txt + ' </span></div>';

    $("body").append(sHtml);
    setTimeout(function () {
      $(".js_common_timingNavlayer_fixed").remove();
    }, 2000)
  }

  $('body').on("mouseenter",".v_search_clear_btn",function(){
    $(this).find('.base_tips').stop().fadeIn()
  }).on("mouseleave",".v_search_clear_btn",function(){
    $(this).find('.base_tips').stop().fadeOut()
  })

  $('body').on("mouseenter",".v_search_btn",function(){
    $(this).find('.base_tips').stop().fadeIn()
  }).on("mouseleave",".v_search_btn",function(){
    $(this).find('.base_tips').stop().fadeOut()
  })
  /* 最新最匹配 */ 
function gioClick(obj,path) {
 
  var user_type = "试用"
    if(P_UserType == "TOURIST"){
      user_type = "游客"
    }else if(P_UserType == "GENERAL"){
      user_type = "普通"
    }else if(P_UserType == "VIP"){
      user_type = "VIP"
    }

    const params = {};
    obj.forEach((value, key)=>{
          params[key] = value
    })
    var search_type = 0
    var search_tag = ""
    var ai_atg = ""
    var popUser = user_type;
    var json = {
    }
    if( !path.includes('/aisearch') && !params.hasOwnProperty('path') && params.hasOwnProperty('key')){
        search_type = 3
    }
    if(path.includes('/aisearch') && params.hasOwnProperty('path') && params.hasOwnProperty('key')){
        search_type = 2
    }
    if(path.includes('/aisearch') && params.hasOwnProperty('path') && !params.hasOwnProperty('key')){
        search_type = 1
    }
    if(params.hasOwnProperty('aitag')){
        ai_atg = decodeURIComponent(params.aitag)
    }
    if(params.hasOwnProperty('key')){
        search_tag = decodeURIComponent(params.key)
    }

    json['search_type'] = search_type
    if(search_tag && search_tag.length > 0){
        json['search_tag'] = search_tag
    }
    if(ai_atg && ai_atg.length > 0){
        json['AI_tag'] = decodeURIComponent(ai_atg)
    }
    if(popUser && popUser.length > 0){
        json['UserIdentity'] = popUser
    }

    gio('track', 'search_click', json);
}


// 最新和最匹配点击
$(".js-new-item").on("click", function () {

})
$("body").on("click",".js-match-item", function () {
  let is_search = window.location.pathname.includes('/search/')
  let url = is_search ? '/aisearch/tab_2/' : '/aisearch/column/tab_2/'
  let tim = 2
  let col = $(this).attr('data-col')
  
  if(col == 700 || col == 701 || col == 70000){
      url = is_search ? '/aisearch/tab_1/' : '/aisearch/column/tab_1/'
      tim = 3
  }
  if(col == 753){
      url = is_search ? '/aisearch/tab_3/' :'/aisearch/column/tab_3/'
  }
  url = url + '?col=' + col
  openSearchResultWithType(url,'',tim,'key_type')
})
// 全栈搜素
$('body').on("click",'.js-normal-match', function () {
 $('.js-match-item').trigger('click')
});



if(window.location.pathname.includes('/search')){
  $('body').on("click", '.js_ai_change',function () {
      $('.js-normal-match').trigger('click')
  });
}else{
  $('body').on("click", '.js_ai_change',function () {
      $('.js-match-item').trigger('click')
  });
}


$('.js-normal-new').on("click", function () {

  var search_url = '/search/'
  let tim = 2
  if(window.location.pathname.includes('/aisearch/column')){
   let col = $(this).attr('data-col') || $('#global_search_value').attr('data-col')
   
    if(col == 700 || col == 70000){
      search_url = '/insight/'
      tim = 3
    }
    if(col == 701 ){
      search_url = '/trends/'
    }
    if(col == 702 ){
      search_url = '/design/'
    }
    if(col == 753){
      search_url = '/patterns/'
    }
   
  }else{
    if(window.location.pathname.includes('tab_2')){
      search_url = '/search/col_702/' 
    }
    if(window.location.pathname.includes('tab_3')){
        search_url = '/search/col_753/' 
    }
   
  }
 
   openSearchResultWithType(search_url,'',tim,'key_type')

  
});

//aitag点击
$('body').on("click", '.js-ai_search_box .tag_wrap .tag',function () {
  let tag = $(this).attr("data-key")
  var urlObj = new URL(window.location.href);

  let params = new URLSearchParams(urlObj.search);
  if(tag){
      params.set('aitag', encodeURIComponent(tag) );
  }
  urlObj.search = params.toString();
  gioClick(params,window.location.pathname)
  window.open(urlObj.toString(), "_self")
  });
  let ai_tag = $('#global_search_value').attr('data-tag')
  $('.js-ai_search_box .tag_wrap .tag').each(function(){
  $(this).removeClass('cur')
  let tag = $(this).attr("data-key")
  if(tag == ai_tag){
      $(this).addClass('cur')
  }

})







$('.first-tips').on("mouseenter",function(e){
  e.stopPropagation();
  // e.preventDefault();
})


$('.first-tips .tip-view .del-btn').on('click',function(e){
  e.stopPropagation();
  $('.search_ipt_box .v_search_pic_btn .first-tips').fadeOut()
})

function isFirstAiTips() {
  // 检查 localStorage 中是否有 firstLogin 标识
  if (!localStorage.getItem('bag_firstAITips')) {

    $('.search_ipt_box .v_search_pic_btn .first-tips').fadeIn()
      localStorage.setItem('bag_firstAITips', 'true');
      return true;
  } else {

      $('.search_ipt_box .v_search_pic_btn .first-tips').fadeOut()
      $('.mask-view').hide()
      return false;
  }
}
if(window.location.pathname == '/'){
  isFirstAiTips()
}


  /* 上传图片-end */ 
  /***************** 导航搜素end *********************/ 
});
